import { jsx as _jsx } from "react/jsx-runtime";
import chunk from 'lodash.chunk';
import styled from 'styled-components';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
const StyledComparisonColumnSection = styled.div `
  grid-row: ${props => props.$row};
  grid-column: ${props => props.$columnStart} / span ${props => props.$columnSpan};
`;
const StyledWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${props => props.$rowGap};
`;
const StyledGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(${props => props.$columns}, minmax(0, 1fr));
  gap: ${props => props.$gridRowGap} ${props => props.$gridColumnGap};
`;
export const GuidaComparisonTable = ({ items, columns, gapColumn = SkapaTokens.space100, gapItemSection = '0', gapRow = SkapaTokens.space200, lastItemConfiguration, renderItem, identity }) => {
    const comparisonRows = chunk(items, columns);
    return (_jsx(StyledWrapper, { "$rowGap": gapRow, children: comparisonRows.map((rowItems, rowIndex) => {
            const isLastRow = rowIndex === comparisonRows.length - 1;
            return (_jsx(GuidaComparisonTableRow, { items: rowItems, columns: columns, isLastRow: isLastRow, identity: identity, renderItem: renderItem, lastItemConfiguration: lastItemConfiguration, gapColumn: gapColumn, gapItemSection: gapItemSection }, rowIndex));
        }) }));
};
const GuidaComparisonTableRow = ({ items: rowItems, identity, columns, renderItem, lastItemConfiguration, isLastRow, gapColumn, gapItemSection }) => {
    const lastItemConfigurationWithDefault = lastItemConfiguration ?? {
        shouldExpand: false,
        maxColumnSpan: 1
    };
    const { shouldExpand } = lastItemConfigurationWithDefault;
    const maxColumnSpan = Math.max(lastItemConfigurationWithDefault.maxColumnSpan, 1);
    return (_jsx(StyledGrid, { "$columns": columns, "$gridColumnGap": gapColumn, "$gridRowGap": gapItemSection, children: rowItems.map((item, itemIndex) => {
            const isLastItem = itemIndex === rowItems.length - 1;
            const shouldExpandItem = shouldExpand && isLastRow && isLastItem;
            const columnStart = itemIndex + 1;
            const columnSpan = shouldExpandItem ? columns - itemIndex : 1;
            const columnSpanConstrained = Math.min(columnSpan, maxColumnSpan);
            const renderedItemContent = renderItem(item, {
                columnSpan: columnSpanConstrained
            });
            // Wrap the content in a wrapper that position the item section
            // in the correct row/col within the grid
            return renderedItemContent.map((section, sectionIndex) => (_jsx(StyledComparisonColumnSection, { "$row": sectionIndex + 1, "$columnStart": columnStart, "$columnSpan": columnSpanConstrained, children: section }, `${identity(item)}-${sectionIndex}`)));
        }) }));
};
//# sourceMappingURL=GuidaComparisonTable.js.map